/**
 * Logo + branding block for the Initialization Loading screen.
 */

import React from "react";

import LogoDevIcon from "@mui/icons-material/LogoDev";
import { Typography, alpha, useTheme } from "@mui/material";
import { motion } from "framer-motion";

import { logoVariants } from "./animationVariants";

export const LoadingBranding: React.FC = () => {
  const theme = useTheme();

  return (
    <motion.div
      variants={logoVariants}
      initial="initial"
      animate="animate"
      transition={{ duration: 0.5, ease: "easeOut" }}
      style={{
        marginBottom: 32,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <motion.div
        animate={{
          scale: [1, 1.05, 1],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        style={{
          width: 80,
          height: 80,
          borderRadius: "50%",
          backgroundColor: alpha(theme.palette.primary.main, 0.1),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 16,
          border: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
        }}
      >
        <LogoDevIcon
          sx={{
            fontSize: 48,
            color: theme.palette.primary.main,
          }}
        />
      </motion.div>
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontWeight: 600,
          letterSpacing: "0.02em",
          color: theme.palette.text.primary,
          mb: 0.5,
        }}
      >
        Rusha
      </Typography>
    </motion.div>
  );
};

export default LoadingBranding;
